/** ISO 6346 shape: 4 letters then 7 digits. The check digit is not calculated. */
const CONTAINER_NUMBER = /^[A-Z]{4}[0-9]{7}$/;

export const MAX_CONTAINER_NUMBERS = 200;

export type ParsedContainerNumbers = {
  valid: string[];
  invalid: string[];
  tooMany: boolean;
};

function tokenize(input: unknown): string[] {
  if (input == null) return [];
  if (Array.isArray(input)) {
    return input.flatMap((item) => tokenize(item));
  }
  if (typeof input === "string") {
    return input.split(/[,;\t\r\n]+/);
  }
  if (typeof input === "number" || typeof input === "boolean") {
    return [String(input)];
  }
  return [];
}

/**
 * Split an Excel paste, a comma-separated line, or a stored list.
 * Spaces inside a token are removed so `MSCU 123456 7` becomes `MSCU1234567`.
 */
export function parseContainerNumbers(input: unknown): ParsedContainerNumbers {
  const valid: string[] = [];
  const invalid: string[] = [];
  const seen = new Set<string>();
  for (const raw of tokenize(input)) {
    const token = raw.replace(/\s+/g, "").toUpperCase();
    if (!token) continue;
    if (!CONTAINER_NUMBER.test(token)) {
      if (!invalid.includes(token)) invalid.push(token);
      continue;
    }
    if (seen.has(token)) continue;
    seen.add(token);
    valid.push(token);
  }
  return {
    valid,
    invalid,
    tooMany: valid.length > MAX_CONTAINER_NUMBERS,
  };
}

/** Keep the stored value editable, including tokens that fail validation. */
export function containerDraftFromStored(input: unknown): string {
  if (Array.isArray(input)) {
    return input
      .map((item) => (item == null ? "" : String(item).trim()))
      .filter((item) => item.length > 0)
      .join("\n");
  }
  if (typeof input === "string") return input;
  return "";
}
